import { AwsSmAccesses } from "@p0security/integrations-aws-sm-shared/accesses";
import { GcpSmAccesses } from "@p0security/integrations-gcp-sm-shared/accesses";
import { Delegate } from "@p0security/shared/types/access/index";

/** The `delegation` and `generated` fields of an access that delivers a shared
 * credential through a vaulted secret. Spread them into the access spec. */
export const VaultedSecretAccess = {
  delegation: {
    awsSm: Delegate({
      resource: "aws-sm",
      accesses: AwsSmAccesses,
      key: "secret",
    }),
    gcpSm: Delegate({
      resource: "gcp-sm",
      accesses: GcpSmAccesses,
      key: "secret",
    }),
  },
  generated: {
    // The shared secret's name, fixed at stage time so an open request always revokes
    // the exact secret it granted, even if the naming scheme changes underneath it.
    secretName: { type: "string", label: "Secret name" },
    // Where that secret lives, so a consumer reads the vault this grant actually
    // wrote to rather than one configured separately.
    vault: {
      type: "object",
      label: "Secret vault",
      properties: {
        provider: {
          type: "string",
          label: "Secret manager provider",
          choices: ["aws", "azure", "gcp"],
        },
        location: {
          type: "string",
          label: "Vault location",
          description:
            "GCP project, AWS account, or Azure Key Vault name, holding the secret",
        },
        // AWS addresses a secret by region as well; GCP does not.
        region: { type: "string", label: "AWS region", optional: true },
        // The audience a consumer federates into the vault's project or
        // account with. Absent unless it has a GCP WIF or aws-oidc install,
        // which only an agentic consumer needs.
        audience: {
          type: "string",
          label: "Federation audience",
          optional: true,
        },
      },
    },
  },
} as const;
